import { Badge } from '@/components/ui/Badge';
import type { AdmissionListRow } from './api';

const DATE_FMT: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' };

export function fmtDate(v: string | null | undefined): string {
  if (!v) return '—';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('en-IN', DATE_FMT);
}

/** Calendar days between admission and discharge (or now), at least 1. */
export function stayDays(row: Pick<AdmissionListRow, 'admitted_at' | 'discharged_at'>): number {
  const start = new Date(row.admitted_at).getTime();
  const end = row.discharged_at ? new Date(row.discharged_at).getTime() : Date.now();
  if (Number.isNaN(start) || Number.isNaN(end)) return 1;
  return Math.max(1, Math.ceil((end - start) / 86_400_000));
}

const DISCHARGE_TYPE_LABEL: Record<string, string> = {
  normal: 'Normal', lama: 'LAMA', dama: 'DAMA', referred: 'Referred',
  absconded: 'Absconded', death: 'Death', 'transfer-out': 'Transferred out',
};

export function dischargeTypeLabel(v: string | null | undefined): string | null {
  if (!v) return null;
  return DISCHARGE_TYPE_LABEL[v] ?? v;
}

export function SummaryStatusBadge({ status }: { status: AdmissionListRow['discharge_summary_status'] }) {
  if (status === 'signed') return <Badge variant="success">Signed</Badge>;
  if (status) return <Badge variant="warn">Draft</Badge>;
  return <Badge variant="neutral">Not started</Badge>;
}

/** Whether the Case Sheet was ever printed (PDF export or filed .docx). */
export function CaseSheetStatusBadge({ row }: { row: Pick<AdmissionListRow, 'case_sheet_count' | 'case_sheet_last_at'> }) {
  if (row.case_sheet_count > 0) {
    return (
      <Badge variant="success" title={`${row.case_sheet_count} generated`}>
        Generated {fmtDate(row.case_sheet_last_at)}
      </Badge>
    );
  }
  return <Badge variant="caution">Not generated</Badge>;
}
